import moment from 'moment';
import downloadjs from 'downloadjs';
// import { luftPost } from '../shared/http';
import { luftGet, luftDownload } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { USER_TYPES } from '../pages/Admin/shared/static-options';
import Mask from '../utils/Mask';

// actions

const SET_GROUPED_OPTION = 'luft/stock/SET_GROUPED_OPTION';

const GET_LIST_OF_COMPANIES = 'luft/stock/GET_LIST_OF_COMPANIES';
const GET_LIST_OF_COMPANIES_SUCCESS =
  'luft/stock/GET_LIST_OF_COMPANIES_SUCCESS';
const GET_LIST_OF_COMPANIES_FAILURE =
  'luft/stock/GET_LIST_OF_COMPANIES_FAILURE';
const GET_LIST_OF_COMPANIES_CLEAR = 'luft/stock/GET_LIST_OF_COMPANIES_CLEAR';

const GET_CURRENT_STOCK = 'luft/stock/GET_CURRENT_STOCK';
const GET_CURRENT_STOCK_SUCCESS = 'luft/stock/GET_CURRENT_STOCK_SUCCESS';
const GET_CURRENT_STOCK_FAILURE = 'luft/stock/GET_CURRENT_STOCK_FAILURE';
const GET_CURRENT_STOCK_CLEAR = 'luft/stock/GET_CURRENT_STOCK_CLEAR';

const GET_CURRENT_STOCK_TOTALIZER = 'luft/stock/GET_CURRENT_STOCK_TOTALIZER';
const GET_CURRENT_STOCK_TOTALIZER_SUCCESS =
  'luft/stock/GET_CURRENT_STOCK_TOTALIZER_SUCCESS';
const GET_CURRENT_STOCK_TOTALIZER_FAILURE =
  'luft/stock/GET_CURRENT_STOCK_TOTALIZER_FAILURE';
const GET_CURRENT_STOCK_TOTALIZER_CLEAR = 'luft/stock/GET_CURRENT_STOCK_CLEAR';

const GET_MOVEMENT_STOCK = 'luft/stock/GET_MOVEMENT_STOCK';
const GET_MOVEMENT_STOCK_SUCCESS = 'luft/stock/GET_MOVEMENT_STOCK_SUCCESS';
const GET_MOVEMENT_STOCK_FAILURE = 'luft/stock/GET_MOVEMENT_STOCK_FAILURE';
const GET_MOVEMENT_STOCK_CLEAR = 'luft/stock/GET_MOVEMENT_STOCK_CLEAR';

const GET_DAILY_MOVIMENTATION = 'luft/stock/GET_DAILY_MOVIMENTATION';
const GET_DAILY_MOVIMENTATION_SUCCESS =
  'luft/stock/GET_DAILY_MOVIMENTATION_SUCCESS';
const GET_DAILY_MOVIMENTATION_FAILURE =
  'luft/stock/GET_DAILY_MOVIMENTATION_FAILURE';
const GET_DAILY_MOVIMENTATION_CLEAR =
  'luft/stock/GET_DAILY_MOVIMENTATION_CLEAR';

const GET_PRODUCT_MOVIMENTATION = 'luft/stock/GET_PRODUCT_MOVIMENTATION';
const GET_PRODUCT_MOVIMENTATION_SUCCESS =
  'luft/stock/GET_PRODUCT_MOVIMENTATION_SUCCESS';
const GET_PRODUCT_MOVIMENTATION_FAILURE =
  'luft/stock/GET_PRODUCT_MOVIMENTATION_FAILURE';
const GET_PRODUCT_MOVIMENTATION_CLEAR =
  'luft/stock/GET_PRODUCT_MOVIMENTATION_CLEAR';

const GET_RECEIVED = 'luft/stock/GET_RECEIVED';
const GET_RECEIVED_SUCCESS = 'luft/stock/GET_RECEIVED_SUCCESS';
const GET_RECEIVED_FAILURE = 'luft/stock/GET_RECEIVED_FAILURE';
const GET_RECEIVED_CLEAR = 'luft/stock/GET_RECEIVED_CLEAR';

const GET_ISSUED = 'luft/stock/GET_ISSUED';
const GET_ISSUED_SUCCESS = 'luft/stock/GET_ISSUED_SUCCESS';
const GET_ISSUED_FAILURE = 'luft/stock/GET_ISSUED_FAILURE';
const GET_ISSUED_CLEAR = 'luft/stock/GET_ISSUED_CLEAR';

const EXPORT_STOCK = 'luft/stock/EXPORT_STOCK';
const EXPORT_STOCK_SUCCESS = 'luft/stock/EXPORT_STOCK_SUCCESS';
const EXPORT_STOCK_FAILURE = 'luft/stock/EXPORT_STOCK_FAILURE';

// reducer

const initialState = {
  grouped: false,
  listOfCompanies: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  stockCurrentList: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  stockCurrentTotalizer: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  stockMovementList: {
    isFetching: false,
    requested: '',
    error: '',
    data: {
      data: [],
      resume: {},
    },
  },
  dailyMovimentation: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  productMovimentation: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  received: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  issued: {
    isFetching: false,
    requested: '',
    error: '',
    data: [],
  },
  exportStock: {
    isFetching: false,
    error: '',
    requested: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_GROUPED_OPTION:
      return {
        ...state,
        grouped: action.grouped,
      };

    case GET_LIST_OF_COMPANIES:
      return {
        ...state,
        listOfCompanies: {
          ...state.listOfCompanies,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_LIST_OF_COMPANIES_SUCCESS:
      return {
        ...state,
        listOfCompanies: {
          ...state.listOfCompanies,
          isFetching: false,
          error: '',
          data: action.listOfCompanies,
        },
      };

    case GET_LIST_OF_COMPANIES_FAILURE:
      return {
        ...state,
        listOfCompanies: {
          ...state.listOfCompanies,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_LIST_OF_COMPANIES_CLEAR:
      return {
        ...state,
        listOfCompanies: {
          ...state.listOfCompanies,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_CURRENT_STOCK:
      return {
        ...state,
        stockCurrentList: {
          ...state.stockCurrentList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_CURRENT_STOCK_SUCCESS:
      return {
        ...state,
        stockCurrentList: {
          ...state.stockCurrentList,
          isFetching: false,
          error: '',
          data: action.stockCurrentList,
        },
      };

    case GET_CURRENT_STOCK_FAILURE:
      return {
        ...state,
        stockCurrentList: {
          ...state.stockCurrentList,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_CURRENT_STOCK_CLEAR:
      return {
        ...state,
        stockCurrentList: {
          ...state.stockCurrentList,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_CURRENT_STOCK_TOTALIZER:
      return {
        ...state,
        stockCurrentTotalizer: {
          ...state.stockCurrentTotalizer,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_CURRENT_STOCK_TOTALIZER_SUCCESS:
      return {
        ...state,
        stockCurrentTotalizer: {
          ...state.stockCurrentTotalizer,
          isFetching: false,
          error: '',
          data: action.stockCurrentTotalizer,
        },
      };

    case GET_CURRENT_STOCK_TOTALIZER_FAILURE:
      return {
        ...state,
        stockCurrentTotalizer: {
          ...state.stockCurrentTotalizer,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_CURRENT_STOCK_TOTALIZER_CLEAR:
      return {
        ...state,
        stockCurrentTotalizer: {
          ...state.stockCurrentTotalizer,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_MOVEMENT_STOCK:
      return {
        ...state,
        stockMovementList: {
          ...state.stockMovementList,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_MOVEMENT_STOCK_SUCCESS:
      return {
        ...state,
        stockMovementList: {
          ...state.stockMovementList,
          isFetching: false,
          error: '',
          data: action.stockMovementList,
        },
      };

    case GET_MOVEMENT_STOCK_FAILURE:
      return {
        ...state,
        stockMovementList: {
          ...state.stockMovementList,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_MOVEMENT_STOCK_CLEAR:
      return {
        ...state,
        stockMovementList: {
          ...state.stockMovementList,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_DAILY_MOVIMENTATION:
      return {
        ...state,
        dailyMovimentation: {
          ...state.dailyMovimentation,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_DAILY_MOVIMENTATION_SUCCESS:
      return {
        ...state,
        dailyMovimentation: {
          ...state.dailyMovimentation,
          isFetching: false,
          error: '',
          data: action.dailyMovimentation,
        },
      };

    case GET_DAILY_MOVIMENTATION_FAILURE:
      return {
        ...state,
        dailyMovimentation: {
          ...state.dailyMovimentation,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_DAILY_MOVIMENTATION_CLEAR:
      return {
        ...state,
        dailyMovimentation: {
          ...state.dailyMovimentation,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_PRODUCT_MOVIMENTATION:
      return {
        ...state,
        productMovimentation: {
          ...state.productMovimentation,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_PRODUCT_MOVIMENTATION_SUCCESS:
      return {
        ...state,
        productMovimentation: {
          ...state.productMovimentation,
          isFetching: false,
          error: '',
          data: action.productMovimentation,
        },
      };

    case GET_PRODUCT_MOVIMENTATION_FAILURE:
      return {
        ...state,
        productMovimentation: {
          ...state.productMovimentation,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_PRODUCT_MOVIMENTATION_CLEAR:
      return {
        ...state,
        productMovimentation: {
          ...state.productMovimentation,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_RECEIVED:
      return {
        ...state,
        received: {
          ...state.received,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_RECEIVED_SUCCESS:
      return {
        ...state,
        received: {
          ...state.received,
          isFetching: false,
          error: '',
          data: action.received,
        },
      };

    case GET_RECEIVED_FAILURE:
      return {
        ...state,
        received: {
          ...state.received,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_RECEIVED_CLEAR:
      return {
        ...state,
        received: {
          ...state.received,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case GET_ISSUED:
      return {
        ...state,
        issued: {
          ...state.issued,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };

    case GET_ISSUED_SUCCESS:
      return {
        ...state,
        issued: {
          ...state.issued,
          isFetching: false,
          error: '',
          data: action.issued,
        },
      };

    case GET_ISSUED_FAILURE:
      return {
        ...state,
        issued: {
          ...state.issued,
          error: action.error,
          isFetching: false,
        },
      };

    case GET_ISSUED_CLEAR:
      return {
        ...state,
        issued: {
          ...state.issued,
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    default:
      return state;
  }
}

export default reducer;

// action creators

export function setGroupedOption(grouped = false) {
  return {
    type: SET_GROUPED_OPTION,
    grouped,
  };
}

function _getListOfCompanies() {
  return { type: GET_LIST_OF_COMPANIES };
}

function _getListOfCompaniesSuccess(listOfCompanies) {
  return { type: GET_LIST_OF_COMPANIES_SUCCESS, listOfCompanies };
}

function _getListOfCompaniesFailure(error) {
  return {
    type: GET_LIST_OF_COMPANIES_FAILURE,
    error,
  };
}

export function listOfCompaniesClear() {
  return { type: GET_LIST_OF_COMPANIES_CLEAR };
}

function _getCurrentStock() {
  return { type: GET_CURRENT_STOCK };
}

function _getCurrentStockSuccess(stockCurrentList) {
  return { type: GET_CURRENT_STOCK_SUCCESS, stockCurrentList };
}

function _getCurrentStockFailure(error) {
  return {
    type: GET_CURRENT_STOCK_FAILURE,
    error,
  };
}

export function currentStockClear() {
  return { type: GET_CURRENT_STOCK_CLEAR };
}

function _getCurrentStockTotalizer() {
  return { type: GET_CURRENT_STOCK_TOTALIZER };
}

function _getCurrentStockTotalizerSuccess(stockCurrentTotalizer) {
  return { type: GET_CURRENT_STOCK_TOTALIZER_SUCCESS, stockCurrentTotalizer };
}

function _getCurrentStockTotalizerFailure(error) {
  return {
    type: GET_CURRENT_STOCK_TOTALIZER_FAILURE,
    error,
  };
}

export function currentStockTotalizerClear() {
  return { type: GET_CURRENT_STOCK_TOTALIZER_CLEAR };
}

export function MovementStockClear() {
  return { type: GET_MOVEMENT_STOCK_CLEAR };
}

function _getMovementStock() {
  return { type: GET_MOVEMENT_STOCK };
}

function _getMovementStockSuccess(stockMovementList) {
  return { type: GET_MOVEMENT_STOCK_SUCCESS, stockMovementList };
}

function _getMovementStockFailure(error) {
  return {
    type: GET_MOVEMENT_STOCK_FAILURE,
    error,
  };
}

export function movementStockClear() {
  return { type: GET_MOVEMENT_STOCK_CLEAR };
}

function _getDailyMovimentation() {
  return {
    type: GET_DAILY_MOVIMENTATION,
  };
}

function _getDailyMovimentationSuccess(dailyMovimentation) {
  return {
    type: GET_DAILY_MOVIMENTATION_SUCCESS,
    dailyMovimentation,
  };
}

function _getDailyMovimentationFailure(error) {
  return {
    type: GET_DAILY_MOVIMENTATION_FAILURE,
    error,
  };
}

export function getDailyMovimentationClear() {
  return {
    type: GET_DAILY_MOVIMENTATION_CLEAR,
  };
}

function _getProductMovimentation() {
  return {
    type: GET_PRODUCT_MOVIMENTATION,
  };
}

function _getProductMovimentationSuccess(productMovimentation) {
  return {
    type: GET_PRODUCT_MOVIMENTATION_SUCCESS,
    productMovimentation,
  };
}

function _getProductMovimentationFailure(error) {
  return {
    type: GET_PRODUCT_MOVIMENTATION_FAILURE,
    error,
  };
}

export function getProductMovimentationClear() {
  return {
    type: GET_PRODUCT_MOVIMENTATION_CLEAR,
  };
}

function _getReceived() {
  return {
    type: GET_RECEIVED,
  };
}

function _getReceivedSuccess(received) {
  return {
    type: GET_RECEIVED_SUCCESS,
    received,
  };
}

function _getReceivedFailure(error) {
  return {
    type: GET_RECEIVED_FAILURE,
    error,
  };
}

export function getReceivedClear() {
  return {
    type: GET_RECEIVED_CLEAR,
  };
}

function _getIssued() {
  return {
    type: GET_ISSUED,
  };
}

function _getIssuedSuccess(issued) {
  return {
    type: GET_ISSUED_SUCCESS,
    issued,
  };
}

function _getIssuedFailure(error) {
  return {
    type: GET_ISSUED_FAILURE,
    error,
  };
}

export function getIssuedClear() {
  return {
    type: GET_ISSUED_CLEAR,
  };
}

// NF Export Excel

function _exportStock() {
  return { type: EXPORT_STOCK };
}

function _exportStockSuccess() {
  return { type: EXPORT_STOCK_SUCCESS };
}

function _exportStockFailure(error) {
  return {
    type: EXPORT_STOCK_FAILURE,
    error,
  };
}

// thunk action creators

export function exportStock() {
  return function (dispatch, getState) {
    (async () => {
      dispatch(_exportStock());

      try {
        const { userType, activeCompanyId } = getState().auth;
        const mimeType = 'application/ms-excel';
        const response = await luftDownload(
          '/Stock/StockExportExcelBase64',
          {
            companyId:
              userType === USER_TYPES.CUSTOMER_SERVICE_USER
                ? activeCompanyId
                : null,
          },
          'application/json' || null,
        );

        const data = `data:${mimeType};base64,${JSON.parse(response).data}`;
        const filename = 'tracking.xlsx';

        downloadjs(data, filename, mimeType);

        dispatch(_exportStockSuccess());
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _exportStockFailure(error.message),
        );
      }
    })();
  };
}

export function getListOfCompanies(query = '') {
  return function (dispatch, getState) {
    return (async () => {
      try {
        dispatch(_getListOfCompanies());

        const { activeCompanyId, userType } = getState().auth;

        const params = {
          query,
          id:
            userType === USER_TYPES.CUSTOMER_SERVICE_USER
              ? activeCompanyId
              : null,
        };

        const response = await luftGet('/Company/GetByCompanyId', params);
        if (response.data.companyCNPJ) {
          const formattedList = response.data.companyCNPJ.map(({ cnpj }) => ({
            label: `${Mask.cnpj(cnpj)}`,
            value: cnpj,
            className: 'Stock__Select-Option',
          }));
          dispatch(_getListOfCompaniesSuccess(formattedList));
          return;
        }
        dispatch(_getListOfCompaniesSuccess(response.data));
      } catch (error) {
        dispatch(_getListOfCompaniesFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getCurrentStock(query = '', companyCNPJ = '') {
  return function (dispatch, getState) {
    return (async () => {
      try {
        dispatch(_getCurrentStock());

        const { activeCompanyId, userType } = getState().auth;

        const params = {
          companyCNPJ,
          query,
          companyId:
            userType === USER_TYPES.CUSTOMER_SERVICE_USER
              ? activeCompanyId
              : null,
        };

        const response = await luftGet('/Stock/getCurrentStock', params);
        dispatch(_getCurrentStockSuccess(response.data));
      } catch (error) {
        dispatch(_getCurrentStockFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getTotalStock(query = '') {
  return function (dispatch, getState) {
    return (async () => {
      try {
        dispatch(_getCurrentStockTotalizer());

        const { activeCompanyId, userType } = getState().auth;

        const params = {
          query,
          companyId:
            userType === USER_TYPES.CUSTOMER_SERVICE_USER
              ? activeCompanyId
              : null,
        };

        const response = await luftGet('/Stock/GetTotalStock', params);
        dispatch(_getCurrentStockTotalizerSuccess(response.data[0]));
      } catch (error) {
        dispatch(_getCurrentStockTotalizerFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getMovementStock(initialDate, finalDate, filialId) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_getMovementStock());
        const requestBody = {
          StartDate: moment(initialDate).format('YYYY-MM-DD'),
          EndDate: moment(finalDate).format('YYYY-MM-DD'),
          filialId,
        };
        const response = await luftGet('/Stock/GetMovementStock', requestBody);
        dispatch(_getMovementStockSuccess(response.data));
        return true;
      } catch (error) {
        dispatch(_getMovementStockFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getDailyMovimentation(startDate, endDate, filialId) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_getDailyMovimentation());
        const requestBody = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          filialId,
        };
        const response = await luftGet(
          '/Stock/GetDailyMovimentation',
          requestBody,
        );
        dispatch(_getDailyMovimentationSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        dispatch(_getDailyMovimentationFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getProductMovimentation(startDate, endDate, filialId) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_getProductMovimentation());
        const requestBody = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          filialId,
        };
        const response = await luftGet(
          '/Stock/GetProductMovimentation',
          requestBody,
        );
        dispatch(_getProductMovimentationSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        dispatch(_getProductMovimentationFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getReceived(startDate, endDate, filialId) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_getReceived());
        const requestBody = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          filialId,
        };
        const response = await luftGet('/Stock/GetReceived', requestBody);
        dispatch(_getReceivedSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        dispatch(_getReceivedFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}

export function getIssued(startDate, endDate, filialId) {
  return function (dispatch) {
    return (async () => {
      try {
        dispatch(_getIssued());
        const requestBody = {
          startDate: moment(startDate).format('YYYY-MM-DD'),
          endDate: moment(endDate).format('YYYY-MM-DD'),
          filialId,
        };
        const response = await luftGet('/Stock/GetShipped', requestBody);
        dispatch(_getIssuedSuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        dispatch(_getIssuedFailure(error.message));
        throw new Error(error.message);
      }
    })();
  };
}
